import axios from "axios";
import API_PATHS from "./apiPaths";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const sendContactMessage = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}${API_PATHS.CONTACT}`, formData);
    return response.data;
  } catch (error) {
    console.error("Error sending contact message:", error);
    throw error;
  }
};
